const KEY = "itpmng_api_key";

export const getApiKey = (): string | null => sessionStorage.getItem(KEY);
export const setApiKey = (key: string): void => sessionStorage.setItem(KEY, key);
export const clearApiKey = (): void => sessionStorage.removeItem(KEY);
